import { gql } from "@apollo/client";

export const CustomerObjectQuery = gql `
query{
    getCustomerObject {
      response
    }
}
`;

export const getCustomerQuery = gql `
query($input: CustomerFilter!){
  customers(input: $input) {
    customers
    {
      _id
      customername
      branch
      branchId
      branchName
      metadata
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
    totalCount
    currentPage
    totalPages
  }
}
`;

export const getSingleCustomerQuery = gql `
query($id: String!){
  customer(_id: $id) {
    _id
    customername
    branch
    branchId
    branchName
    metadata
  }
}
`;


export const getCustomerBySiteId = gql`
query($siteId: String!){
  getCustomerBySiteId(siteId: $siteId) {
    message
    response
  }
}
`;